import { useUser } from "@tm/context-distribution"
import { useState, useEffect } from "react"

export const useUserSettingChanged = (iframeId: string, setLoading: (v: boolean) => void) => {
    const userSettings = useUser()?.userSettings
    const [localUserSettings, setLocalUserSettings] = useState(userSettings)

    useEffect(() => {
        if (userSettings && userSettings !== localUserSettings) {
            setLocalUserSettings(userSettings)
            const iframe = document.getElementById(iframeId) as HTMLIFrameElement | null

            if (iframe) {
                const url = iframe.src
                iframe.src = url
            }

            setLoading(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [iframeId, localUserSettings, userSettings])
}
